export const SALE_STATUSES = {
  pending: { 
    label: 'Pendiente',
    className: 'bg-amber-50 dark:bg-amber-900/50 text-amber-600 dark:text-amber-400',
    actions: []
  },
  confirmed: { 
    label: 'Confirmada',
    className: 'bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400',
    actions: [
      { icon: 'DollarSign', label: 'Registrar pago', color: 'bg-green-500 dark:bg-green-600' },
      { icon: 'Package', label: 'Marcar entregado', color: 'bg-blue-500 dark:bg-blue-600' }
    ]
  },
  paid: { 
    label: 'Pagada',
    className: 'bg-green-50 dark:bg-green-900/50 text-green-600 dark:text-green-400',
    actions: [
      { icon: 'Package', label: 'Marcar entregado', color: 'bg-blue-500 dark:bg-blue-600' }
    ]
  },
  completed: { 
    label: 'Completada',
    className: 'bg-green-50 dark:bg-green-900/50 text-green-600 dark:text-green-400',
    actions: []
  },
  canceled: { 
    label: 'Cancelada',
    className: 'bg-red-50 dark:bg-red-900/50 text-red-600 dark:text-red-400',
    actions: []
  }
}; 